var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.14 0.774763C14.8624 0.783316 14.5991 0.897422 14.4061 1.0927C11.7913 3.65418 9.17455 6.20308 6.55688 8.76502L2.50307 5.46301C2.28523 5.28556 2.00427 5.20003 1.72182 5.22533C1.43937 5.25044 1.17888 5.38439 0.997381 5.59731C0.816037 5.81042 0.728718 6.08506 0.754408 6.36114C0.780288 6.63722 0.917322 6.89184 1.13516 7.06907L5.93962 10.9826C6.1448 11.1504 6.40695 11.2368 6.67411 11.2248C6.94129 11.2126 7.19412 11.103 7.38272 10.9174C10.2282 8.13007 13.0752 5.35931 15.924 2.56861C16.1327 2.37152 16.2504 2.09983 16.25 1.8161C16.2496 1.53238 16.131 1.26104 15.9216 1.06466C15.7121 0.8683 15.4299 0.763656 15.1398 0.774935L15.14 0.774763Z",
    fill: "#7AD81B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTab);
export default __webpack_public_path__ + "static/media/CheckTab.981ebaa184f02806b864872082878bdb.svg";
export { ForwardRef as ReactComponent };